<template>
  <transition name="slide-in">
    <div class="gdpr-prompt" v-if="isPromptVisible">
        <p class="gdpr-text">Използваме "бисквитки" за да персонализираме съдържанието и функциите на този сайт и да анализираме трафика си. За осигуряване на правата ви по GDPR, молим за Вашето съгласие. </p>
        <p class="gdpr-prompt-row">
            <span class="btn-accept" @click="accept()"><span class="alcomet">r</span> Приемам</span>
            <router-link class="btn-link" to="/personal-data">Прочети още</router-link>
        </p>
    </div>
  </transition>
</template>

<script>
export default {
  data() {
    return {
      isPromptVisible: false
    };
  },
  methods: {
    accept() {
      localStorage.setItem("termsAccepted", true);
      this.isPromptVisible = false;
    }
  },
  mounted() {
    const accepted = localStorage.getItem("termsAccepted");
    setTimeout(() => {
      if (accepted) {
        this.isPromptVisible = false;
      } else {
        this.isPromptVisible = true;
      }
    }, 5000);
  }
};
</script>

<style>
.gdpr-prompt {
  align-items: center;
  background-color: rgba(255, 255, 255, 0.9);
  border-radius: 6px;
  bottom: 50px;
  -webkit-box-shadow: 0 0 50px rgba(0, 0, 0, 0.2);
  -moz-box-shadow: 0 0 50px rgba(0, 0, 0, 0.2);
  box-shadow: 0 0 50px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  justify-content: center;
  right: 50px;
  padding: 25px;
  position: fixed;
  width: 300px;
  z-index: 10;
}
.gdpr-prompt-row {
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  width: 100%;
}
.btn-accept {
  align-items: center;
  border: 1px solid #588cc1;
  border-radius: 30px;
  cursor: pointer;
  display: inline-flex;
  font-size: 14px;
  font-weight: 700;
  height: 35px;
  justify-content: center;
  line-height: initial;
  overflow: hidden;
  padding: 8px 20px 8px 10px;
  position: relative;
  -webkit-transition: all 0.2s ease;
  -moz-transition: all 0.2s ease;
  -ms-transition: all 0.2s ease;
  -o-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.btn-accept span {
  margin-right: 10px;
}
.btn-accept:hover {
  background-color: #dde7ee;
}
.btn-link {
  text-decoration: underline;
}
.gdpr-text {
  width: 100%;
}
.slide-in-enter-active,
.slide-in-leave-active {
  -webkit-transition: all 0.6s ease;
  -moz-transition: all 0.6s ease;
  -ms-transition: all 0.6s ease;
  -o-transition: all 0.6s ease;
  transition: all 0.6s ease;
}
.slide-in-leave-to,
.slide-in-enter {
  opacity: 0;
  transform: translateY(100%);
}
@media screen and (max-width: 1280px) {
  .btn-accept {
    font-size: 12px;
  }
  .gdpr-prompt p {
    font-size: 14px;
  }
}
@media screen and (max-width: 440px) {
  .gdpr-prompt {
    bottom: 30px;
    right: 30px;
    width: calc(100% - 60px);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/GDPRPrompt.vue